import { render, staticRenderFns } from "./TiposCotas.vue?vue&type=template&id=38bdec8e&"
import script from "./TiposCotas.vue?vue&type=script&lang=js&"
export * from "./TiposCotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports